import utils from 'Utils';
import csvConfig from 'Config/csv';

const { mapKV } = utils.obj;
const { pipeAll } = utils.fpHelpers;
const { escapeCSVQuotes, escapeNewLines } = utils.string;

const escString = pipeAll([
  escapeNewLines,
  escapeCSVQuotes,
  (str) => `"${str}"`,
]);

/**
 * Assemble footer values (notes & sources)
 * @param  {array} indicators indicators in table
 * @return {string}           footer
 */
export default function buildFooter(indicators) {
  const output = indicators
    .reduce((acc, item) => {
      const {
        activeYear,
        title,
        config: {
          footnotes: footnotesWrapper,
          notesSources: notes,
        },
      } = item;
      const { footnotes } = footnotesWrapper || [];
      const mappedFootnotes = footnotes ? {
        Footnotes: footnotes.sort((a, b) =>
            a.key.geography.localeCompare(b.key.geography))
          .map(({
            key: { geography },
            value: text,
          }) => `${geography}: ${text}`)
          .reduce((compiledFootnotes, curr) =>
            compiledFootnotes.concat(curr), []
          ),
      } : [];

      const mappedNotes = mapKV(notes, (val) => (
        val.filter(({ key: limits }) => (
          // Filter out notes/sources/defs for non-active years
          'undefined' === typeof limits ||
            'undefined' === typeof limits.timeframe ||
            activeYear === limits.timeframe
        ))
          .map(({ value: text }) => text)
          .reduce((acc2, curr) => acc2.concat(curr), [])
      ), false);
      const allMapped = {
        ...mappedFootnotes,
        ...mappedNotes,
      };
      return acc.concat(
        '', // This is for a break between titles
        escString(title),
        ...mapKV(allMapped, (val, key) => [key, ...val], true)
          .reduce((acc1, val) => acc1.concat(escString(val)), [])
      );
    }, []);

  return [
    '\n',
    csvConfig.footer,
    ...output,
  ].join('\n');
}



// WEBPACK FOOTER //
// ./app/services/download/buildFooter.js